import React, { useState, useEffect } from 'react'
import './portfolio.css'

// ── IMPORT PROFILE IMAGE ─────────────────────────────────────────────────────
// This tells Vite to resolve and bundle your image properly!
import profileImg from '../../assets/portfolio.jpeg'

// ── ACCENT COLORS ────────────────────────────────────────────────────────────
const ACCENT_COLORS = [
   { name: 'rose',    hex: '#d9608a' },
  { name: 'violet',  hex: '#8b6ff0' },
  { name: 'amber',   hex: '#c4922a' },
  { name: 'emerald', hex: '#2ea878' },
  { name: 'sky',     hex: '#2e9cc4' },
]

// ── PIXEL ART ICONS (16×16 SVG) ──────────────────────────────────────────────
const icons = {
  about: (color = 'currentColor') => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="5" y="1" width="6" height="6" fill={color}/>
      <rect x="3" y="9" width="10" height="6" fill={color}/>
      <rect x="6" y="7" width="4" height="2" fill={color}/>
    </svg>
  ),
  projects: (color = 'currentColor') => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="2" y="10" width="2" height="5" fill={color}/>
      <rect x="3" y="9" width="2" height="2" fill={color}/>
      <rect x="4" y="7" width="8" height="3" fill={color}/>
      <rect x="11" y="5" width="3" height="2" fill={color}/>
      <rect x="11" y="9" width="3" height="2" fill={color}/>
      <rect x="5" y="2" width="4" height="4" fill={color}/>
      <rect x="6" y="1" width="2" height="1" fill={color}/>
    </svg>
  ),
  cv: (color = 'currentColor') => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="2" y="1" width="9" height="14" fill={color} opacity="0.25"/>
      <rect x="2" y="1" width="9" height="14" stroke={color} strokeWidth="1" fill="none"/>
      <rect x="9" y="1" width="2" height="2" fill="var(--bg)"/>
      <rect x="9" y="1" width="2" height="2" stroke={color} strokeWidth="1" fill="none"/>
      <rect x="4" y="5" width="5" height="1" fill={color}/>
      <rect x="4" y="7" width="5" height="1" fill={color}/>
      <rect x="4" y="9" width="3" height="1" fill={color}/>
    </svg>
  ),
  sun: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="6" y="0" width="2" height="2" fill="currentColor"/>
      <rect x="6" y="12" width="2" height="2" fill="currentColor"/>
      <rect x="0" y="6" width="2" height="2" fill="currentColor"/>
      <rect x="12" y="6" width="2" height="2" fill="currentColor"/>
      <rect x="2" y="2" width="2" height="2" fill="currentColor"/>
      <rect x="10" y="2" width="2" height="2" fill="currentColor"/>
      <rect x="2" y="10" width="2" height="2" fill="currentColor"/>
      <rect x="10" y="10" width="2" height="2" fill="currentColor"/>
      <rect x="4" y="4" width="6" height="6" fill="currentColor"/>
    </svg>
  ),
  moon: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="4" y="0" width="4" height="2" fill="currentColor"/>
      <rect x="2" y="2" width="2" height="2" fill="currentColor"/>
      <rect x="0" y="4" width="2" height="6" fill="currentColor"/>
      <rect x="2" y="10" width="2" height="2" fill="currentColor"/>
      <rect x="4" y="12" width="8" height="2" fill="currentColor"/>
      <rect x="12" y="8" width="2" height="4" fill="currentColor"/>
      <rect x="10" y="6" width="2" height="2" fill="currentColor"/>
      <rect x="8" y="4" width="2" height="2" fill="currentColor"/>
      <rect x="8" y="0" width="2" height="4" fill="currentColor"/>
    </svg>
  ),
  email: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="1" y="2" width="12" height="10" stroke={color} strokeWidth="1" fill="none" opacity="0.4"/>
      <rect x="1" y="2" width="12" height="10" fill="none"/>
      <path d="M1 2 L7 8 L13 2" stroke={color} strokeWidth="1" fill="none"/>
    </svg>
  ),
  linkedin: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="1" y="1" width="3" height="3" fill={color}/>
      <rect x="1" y="5" width="3" height="8" fill={color}/>
      <rect x="5" y="5" width="3" height="8" fill={color}/>
      <rect x="8" y="6" width="2" height="2" fill={color}/>
      <rect x="10" y="5" width="3" height="8" fill={color}/>
    </svg>
  ),
  github: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="4" y="0" width="6" height="2" fill={color}/>
      <rect x="2" y="2" width="2" height="2" fill={color}/>
      <rect x="10" y="2" width="2" height="2" fill={color}/>
      <rect x="1" y="4" width="2" height="5" fill={color}/>
      <rect x="11" y="4" width="2" height="5" fill={color}/>
      <rect x="3" y="9" width="2" height="2" fill={color}/>
      <rect x="9" y="9" width="2" height="2" fill={color}/>
      <rect x="4" y="3" width="6" height="7" fill={color} opacity="0.3"/>
      <rect x="5" y="11" width="1" height="3" fill={color}/>
      <rect x="8" y="11" width="1" height="3" fill={color}/>
    </svg>
  ),
  medium: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="0" y="3" width="2" height="2" fill={color}/>
      <rect x="1" y="5" width="1" height="6" fill={color}/>
      <rect x="2" y="3" width="4" height="2" fill={color}/>
      <rect x="5" y="5" width="1" height="4" fill={color}/>
      <rect x="6" y="3" width="2" height="2" fill={color}/>
      <rect x="7" y="5" width="1" height="6" fill={color}/>
      <rect x="9" y="3" width="5" height="8" fill={color} opacity="0.5"/>
      <rect x="9" y="3" width="5" height="2" fill={color}/>
      <rect x="9" y="9" width="5" height="2" fill={color}/>
    </svg>
  ),
  tools: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="0" y="5" width="8" height="3" fill={color}/>
      <rect x="7" y="3" width="2" height="7" fill={color}/>
      <rect x="8" y="4" width="4" height="5" fill={color} opacity="0.5"/>
      <rect x="8" y="4" width="4" height="2" fill={color}/>
      <rect x="8" y="7" width="4" height="2" fill={color}/>
    </svg>
  ),
  current: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="1" y="1" width="12" height="12" stroke={color} strokeWidth="1" fill="none" opacity="0.3"/>
      <rect x="6" y="3" width="2" height="4" fill={color}/>
      <rect x="6" y="8" width="2" height="2" fill={color}/>
    </svg>
  ),
  books: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="1" y="1" width="4" height="12" fill={color}/>
      <rect x="6" y="1" width="4" height="12" fill={color} opacity="0.6"/>
      <rect x="11" y="2" width="3" height="11" fill={color} opacity="0.35"/>
    </svg>
  ),
  music: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="4" y="0" width="7" height="2" fill={color}/>
      <rect x="10" y="2" width="1" height="5" fill={color}/>
      <rect x="4" y="2" width="1" height="7" fill={color}/>
      <rect x="1" y="9" width="5" height="4" rx="2" fill={color}/>
      <rect x="7" y="7" width="5" height="4" rx="2" fill={color} opacity="0.6"/>
    </svg>
  ),
  languages: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="0" y="1" width="6" height="6" stroke={color} strokeWidth="1" fill="none" opacity="0.4"/>
      <rect x="2" y="3" width="2" height="1" fill={color}/>
      <rect x="2" y="5" width="2" height="1" fill={color}/>
      <rect x="8" y="7" width="6" height="6" stroke={color} strokeWidth="1" fill="none" opacity="0.4"/>
      <rect x="10" y="9" width="2" height="1" fill={color}/>
      <rect x="10" y="11" width="2" height="1" fill={color}/>
      <rect x="5" y="5" width="4" height="2" fill={color}/>
    </svg>
  ),
  writing: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="8" y="1" width="2" height="2" fill={color}/>
      <rect x="7" y="3" width="2" height="2" fill={color}/>
      <rect x="6" y="5" width="2" height="2" fill={color}/>
      <rect x="5" y="7" width="2" height="2" fill={color}/>
      <rect x="4" y="9" width="2" height="2" fill={color}/>
      <rect x="1" y="11" width="6" height="2" fill={color}/>
      <rect x="10" y="1" width="3" height="3" fill={color} opacity="0.5"/>
    </svg>
  ),
  games: (color = 'currentColor') => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges">
      <rect x="1" y="4" width="12" height="8" stroke={color} strokeWidth="1" fill="none" opacity="0.3"/>
      <rect x="1" y="4" width="12" height="8" fill="none"/>
      <rect x="3" y="6" width="1" height="4" fill={color}/>
      <rect x="2" y="7" width="3" height="2" fill={color}/>
      <rect x="9" y="6" width="2" height="2" fill={color}/>
      <rect x="11" y="8" width="2" height="2" fill={color}/>
    </svg>
  )
}

// ── DATA ──────────────────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: 'about',    label: 'About',    icon: 'about'    },
  { id: 'projects', label: 'Projects', icon: 'projects' },
  { id: 'cv',       label: 'CV',       icon: 'cv'       },
]

const CONTACT_LINKS = [
  { label: 'Email',    href: 'mailto:loubnabouzenzen@outlook.com',               icon: 'email'    },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/loubna-bouzenzen-86a6441b8/', icon: 'linkedin' },
  { label: 'GitHub',   href: 'https://github.com/Elby2112',      icon: 'github'   },
  { label: 'Medium',   href: 'https://medium.com/@iamloubna',     icon: 'medium'   },
]

const PROJECTS = [
  {
    id: 1, year: '2024', title: 'Prospera – AI assistant empowering you to earn what you deserve',
    desc: 'Leverages Gemini AI to help women compare market salaries, train to negotiate, and get profile-tailored career tips.',
    tags: ['React', 'Go', 'Gemini',],
    links: { article:'https://devpost.com/software/prospera-74c1le',demo: 'https://www.youtube.com/watch?v=eeTv_fCXkmw', source: 'https://github.com/doniacld/prospera' },
  },
  {
    id: 2, year: '2025', title: 'Gluce – Personalized Metabolic Health Assessment Web App',
    desc: 'Analyzes user data with ML to predict metabolic health risks like metabolic syndrome, and delivers actionable insights to improve overall health.',
    tags: ['Health', 'React', 'Python'],
    links: { source: 'https://github.com/Elby2112/GLUCE' },
  },
  {
    id: 3, year: '2025', title: 'AppWhiz – An AI-Powered Game to Guess the App Behind a Fictional Story',
    desc: 'Read a fictional short story and guess which real-world app inspired it. A creative mix of storytelling, reasoning, and learning wrapped in fun gameplay.',
    tags: ['React', 'Game', 'Perplexity', 'Python'],
    links: { demo: 'https://www.youtube.com/watch?v=fzAtj5TnM0M', source: 'https://github.com/Elby2112/appwhiz-perplexity-backend' },
  },
  {
    id: 4, year: '2025', title: 'PauZ – AI Journaling Assistant for Reflection & Insight',
    desc: 'An AI journaling assistant that helps users reflect on thoughts and feelings, providing personalized prompts and voice-powered insights.',
    tags: ['Python', 'React','Raindrop', 'LiquidmetalAI', 'Vultr', 'ElevelnLabs', 'Gemini'],
    links: { article: 'https://medium.com/@Loubna-DS/pauz-my-ai-powered-journaling-assistant-a4b9295a7a59', source: 'https://www.youtube.com/watch?v=fzAtj5TnM0M', demo: 'https://www.youtube.com/watch?v=vQgk3l4Avk4&list=LL&index=2&t=24s' },
  },
  
]

const ABOUT_CARDS = [
  {
    id: 'tools',
    title: 'Tools & Stack',
    iconKey: 'tools',
    items: [
      'Python, PyCharm',
      'VS Code, Eclipse',
      'React, Flutter',
    ],
  },
  {
    id: 'current',
    title: 'What I\'m doing ',
    iconKey: 'current',
    items: [
      'Working full time',
      'Tweaking this website',
      'Looking for PhD opportunities',
    ],
  },
  {
    id: 'books',
    title: 'Books',
    iconKey: 'books',
    items: [
      "Where's My Happy Ending",
      'Change Your Life with NLP',
      'Stress Less, Accomplish More',
    ],
  },
  {
    id: 'music',
    title: 'Songs / Listening to',
    iconKey: 'music',
    items: [
      'Taylor Swift — Oplaite',
      'Gracie Abrams — Close to You',
      'Taylor Swift — Call It What You Want',
    ],
  },
  {
    id: 'languages',
    title: 'Languages',
    iconKey: 'languages',
    items: [
      'Arabic — native',
      'French — fluent',
      'English — fluent',
    ],
  },
  {
    id: 'writing',
    title: 'Writing',
    iconKey: 'writing',
    items: [
      'The In Between ',
      'Before We Get Older ',
      'Medium — software & thoughts',
    ],
  },
  {
    id: 'contact',
    title: 'Contact',
    iconKey: 'email',
    items: [
      'loubnabouzenzen@outlook.com',
      'LinkedIn — loubna-bouzenzen',
      'GitHub — Elby2112',
      'Medium — @iamloubna',
    ],
  },
]

// ── HELPERS ───────────────────────────────────────────────────────────────────
function useTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem('pf-dark') === 'true')
  
  const [accent, setAccent] = useState(() =>
    localStorage.getItem('pf-accent') || ACCENT_COLORS[0].hex
  )

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
    localStorage.setItem('pf-dark', dark)
  }, [dark])

  useEffect(() => {
    document.documentElement.style.setProperty('--accent', accent)
    localStorage.setItem('pf-accent', accent)
  }, [accent])

  return { dark, setDark, accent, setAccent }
}

// ── SUB-COMPONENTS ────────────────────────────────────────────────────────────
function ColorPicker({ accent, setAccent }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="pf-color-picker">
      <button
        className="pf-color-btn"
        style={{ background: accent }}
        onClick={() => setOpen(o => !o)}
        aria-label="Choose accent colour"
      />
      {open && (
        <div className="pf-color-dropdown">
          {ACCENT_COLORS.map(c => (
            <button
              key={c.name}
              className={`pf-color-swatch${accent === c.hex ? ' active' : ''}`}
              style={{ background: c.hex }}
              onClick={() => { setAccent(c.hex); setOpen(false) }}
              aria-label={c.name}
            />
          ))}
        </div>
      )}
    </div>
  )
}

function Sidebar({ active, setActive, dark, setDark, accent, setAccent }) {
  return (
    <aside className="pf-sidebar">
      <div className="pf-sidebar-header">
        <span className="pf-name">Loubna Bouzenzen</span>
        <div className="pf-sidebar-controls">
          <ColorPicker accent={accent} setAccent={setAccent} />
          <button
            className="pf-mode-btn"
            onClick={() => setDark(d => !d)}
            aria-label="Toggle dark mode"
          >
            {dark ? icons.sun() : icons.moon()}
          </button>
        </div>
      </div>

      <hr className="pf-divider" />

      <p className="pf-sidebar-bio">
  I'm <strong>Loubna</strong> — software engineer and author. I build things and write about them. Open to PhD opportunities.
</p>

      <hr className="pf-divider" />

      <nav className="pf-nav">
        {NAV_ITEMS.map(item => (
          <button
            key={item.id}
            className={`pf-nav-item${active === item.id ? ' active' : ''}`}
            onClick={() => setActive(item.id)}
          >
            <span className="pf-nav-icon">
              {icons[item.icon](active === item.id ? accent : 'currentColor')}
            </span>
            {item.label}
          </button>
        ))}
      </nav>

      <hr className="pf-divider" />

      <div className="pf-contact-section">
        <p className="pf-section-label">Connect</p>
        {CONTACT_LINKS.map(c => (
          <a key={c.label} href={c.href} className="pf-contact-link" target="_blank" rel="noreferrer">
            {icons[c.icon]()}
            {c.label}
          </a>
        ))}
      </div>
    </aside>
  )
}

function ProjectCard({ project }) {
  return (
    <div className="pf-project-card">
      <div className="pf-card-top">
        <span className="pf-card-year">{project.year}</span>
      </div>
      <h3 className="pf-card-title">{project.title}</h3>
      <p className="pf-card-desc">{project.desc}</p>
      <div className="pf-card-tags">
        {project.tags.map(t => <span key={t} className="pf-tag">{t}</span>)}
      </div>
      <div className="pf-card-links">
        {project.links.article && <a href={project.links.article} className="pf-link-btn">Article</a>}
        {project.links.demo    && <a href={project.links.demo}    className="pf-link-btn">Demo</a>}
        {project.links.source  && <a href={project.links.source}  className="pf-link-btn" target="_blank" rel="noreferrer">Source</a>}
      </div>
    </div>
  )
}

function AboutCard({ card, accent }) {
  const iconFn = icons[card.iconKey]
  return (
    <div className="pf-about-card">
      <div className="pf-about-card-header">
        <span>{iconFn ? iconFn(accent) : null}</span>
        <span className="pf-about-card-title">{card.title}</span>
      </div>
      <div className="pf-about-card-body">
        <ul>
          {card.items.map((item, i) => <li key={i}>{item}</li>)}
        </ul>
      </div>
    </div>
  )
}

// ── SECTIONS ──────────────────────────────────────────────────────────────────
function ProjectsSection() {
  return (
    <section className="pf-section">
      <div className="pf-section-header">
        <span className="pf-section-emoji">{icons.projects()}</span>
        <h2>Projects</h2>
      </div>
      <p className="pf-section-sub">
        Side projects I build for fun, learning, and personal growth
      </p>
      <div className="pf-projects-grid">
        {PROJECTS.map(p => <ProjectCard key={p.id} project={p} />)}
      </div>
    </section>
  )
}

function AboutSection({ accent }) {
  const [imgFailed, setImgFailed] = useState(false);
  return (
    <section className="pf-section">
      <div className="pf-section-header">
       {/* <span className="pf-section-emoji">{icons.about()}</span>*/}
        <h2>Hey, I'm Loubna</h2>
      </div>
      <div className="pf-about-hero">
        <div className="pf-about-text">
         <div className="pf-about-text">
  <p>
   I'm a software engineer with a Master's in Big Data and ML. I'm passionate about optimization and mathematical modeling, and I'm <span className="pf-accent-text">open to PhD opportunities</span> in optimization, operational research, or related fields. If you have something, let's talk.
  </p>
 <p>
  I'm also a published author of <a href="/my-books" className="pf-accent-text">2 books</a>.
</p>
  <div className="pf-phd-badge">
    {icons.cv(accent)}
    Open to PhD opportunities — 2026/2027
  </div>
</div>
        </div>
        <div className="pf-about-photo-wrap">
          <div className="pf-splash" />
          <div className="pf-about-photo">
            {!imgFailed ? (
              <img 
                src={profileImg} 
                alt="Loubna Bouzenzen" 
                onError={() => setImgFailed(true)} 
              />
            ) : (
              <div className="pf-photo-fallback">L</div>
            )}
          </div>
        </div>
      </div>
      <div className="pf-about-grid">
        {ABOUT_CARDS.map(card => <AboutCard key={card.id} card={card} accent={accent} />)}
      </div>
    </section>
  )
}

function CVSection() {
  return (
    <section className="pf-section">
      <div className="pf-section-header">
        <span className="pf-section-emoji">{icons.cv()}</span>
        <h2>Resume</h2>
      </div>
      <div className="pf-cv-viewer">
        <div className="pf-cv-toolbar">
          <div className="pf-cv-toolbar-title">{icons.cv()} LoubnaBouzenzen_CV.pdf</div>
          <a className="pf-download-btn" href="/LoubnaBouzenzen_CV.pdf" download>Download PDF</a>
        </div>
        <div className="pf-cv-frame-container">
          <iframe className="pf-cv-frame" src="/LoubnaBouzenzen_CV.pdf" title="Loubna's CV" />
        </div>
      </div>
    </section>
  )
}

// ── ROOT ──────────────────────────────────────────────────────────────────────
export default function Portfolio() {
  const { dark, setDark, accent, setAccent } = useTheme()
  const [active, setActive] = useState('about')
  return (
    <div className="pf-root" id="pf-root-element">
      <Sidebar active={active} setActive={setActive} dark={dark} setDark={setDark} accent={accent} setAccent={setAccent} />
      <main className="pf-main">{active === 'projects' ? <ProjectsSection /> : active === 'cv' ? <CVSection /> : <AboutSection accent={accent} />}</main>
    </div>
  )
}